import React, { Suspense, useEffect } from 'react'
import styles from './CrmLayout.module.scss'
import CrmTabs from '../CrmTabs/CrmTabs'
import { Outlet, useLocation } from 'react-router'
import PageSpinner from '@components/ui/PageSpinner/PageSpinner'
import Box from '@components/ui/Box/Box'
import ButtonUi from '@components/ui/ButtonUi/ButtonUi'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { CrmInfoState, useCrmInfo } from './CrmLayout.context'
import { IconAngleLeftCircle } from '@utils/icons'

type LocationState = {
  crmId: string
  crmName: string
}

const CrmLayout: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const crmData = location.state as LocationState
  const [crmInfo, setCrmInfo] = useCrmInfo()

  useEffect(() => {
    if (crmData) {
      setCrmInfo({
        id: crmData?.crmId,
        name: crmData?.crmName,
      })
    }
  }, [crmData])

  return (
    <div className={styles.container}>
      <>
        <div className={styles.header}>
          <div className={styles.crmInfo}>
            <div className={styles.crmName}>CRM: {crmInfo?.name}</div>
          </div>
          <div className={styles.headerBtn}>
            <ButtonUi color='grey' onClick={() => navigate(-1)}>
              <IconAngleLeftCircle width='18' height='18' fill='var(--color-grey)' />
              Назад
            </ButtonUi>
          </div>
        </div>
        <CrmTabs {...crmData} />
        <Suspense fallback={<PageSpinner />}>
          <Outlet />
        </Suspense>
      </>
    </div>
  )
}

export default () => (
  <CrmInfoState>
    <CrmLayout />
  </CrmInfoState>
)
